import { render, staticRenderFns } from "./DataFieldsDeletedDialog.vue?vue&type=template&id=2472ee26"
import script from "./DataFieldsDeletedDialog.vue?vue&type=script&lang=ts"
export * from "./DataFieldsDeletedDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports